import { render } from "./rqzjTreeDetail.vue?vue&type=template&id=0d581de8"
import script from "./rqzjTreeDetail.vue?vue&type=script&lang=js"
export * from "./rqzjTreeDetail.vue?vue&type=script&lang=js"

import "./rqzjTreeDetail.vue?vue&type=style&index=0&id=0d581de8&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__